'use client';

import { useFormikContext } from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormSubmitStatus from '../forms/form-submit-status';
import FormSavingBar from '../forms/form-saving-bar';

type Props = {
  eventStatus: string;
  onPublish: () => void;
};

const EventFormActions = ({ eventStatus, onPublish }: Props) => {
  const { submitForm, isSubmitting } = useFormikContext();
  const isDraft = eventStatus === 'DRAFT' || !eventStatus;

  if (eventStatus === 'CANCELLED') {
    return null;
  }

  if (eventStatus === 'GROUP_PENDING') {
    return (
      <Box sx={{ mt: 3 }}>
        <FormSavingBar />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            type="button"
            variant="contained"
            disabled={isSubmitting}
            onClick={() => submitForm()}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
          <Typography variant="body2" color="text.secondary">
            Pending group approval
          </Typography>
          <FormSubmitStatus successMessage="Saved!" />
        </Box>
      </Box>
    );
  }

  if (isDraft) {
    return (
      <Box sx={{ mt: 3 }}>
        <FormSavingBar />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button
            type="button"
            variant="contained"
            color="inherit"
            disabled={isSubmitting}
            onClick={() => submitForm()}
          >
            {isSubmitting ? 'Saving...' : 'Save Draft'}
          </Button>
          <Button
            type="button"
            variant="contained"
            disabled={isSubmitting}
            onClick={onPublish}
          >
            Publish
          </Button>
          <FormSubmitStatus successMessage="Draft saved" />
        </Box>
      </Box>
    );
  }

  // PUBLISHED
  return (
    <Box sx={{ mt: 3 }}>
      <FormSavingBar />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          type="button"
          variant="contained"
          disabled={isSubmitting}
          onClick={() => submitForm()}
        >
          {isSubmitting ? 'Saving...' : 'Save Changes'}
        </Button>
        <FormSubmitStatus successMessage="Saved!" />
      </Box>
    </Box>
  );
};

export default EventFormActions;
